import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const PlayCircleOutlineIcon: React.FC<OneColorIconProps> = ({ size = 22, color = 'white', className }) => {
  return (
    <svg
      data-testid="play-circle-outline-icon"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 9.325V14.675C9.5 15.075 9.675 15.3667 10.025 15.55C10.375 15.7333 10.7167 15.7167 11.05 15.5L15.2 12.85C15.5167 12.6667 15.675 12.3833 15.675 12C15.675 11.6167 15.5167 11.3333 15.2 11.15L11.05 8.5C10.7167 8.28333 10.375 8.26667 10.025 8.45C9.675 8.63333 9.5 8.925 9.5 9.325ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22ZM12 20C14.2167 20 16.1043 19.221 17.663 17.663C19.221 16.1043 20 14.2167 20 12C20 9.78333 19.221 7.89567 17.663 6.337C16.1043 4.779 14.2167 4 12 4C9.78333 4 7.896 4.779 6.338 6.337C4.77933 7.89567 4 9.78333 4 12C4 14.2167 4.77933 16.1043 6.338 17.663C7.896 19.221 9.78333 20 12 20Z"
        fill={getHexColor(color)}
      />
    </svg>
  )
}
